import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import HamburgerButton from './HamburgerButton.vue'
import { dispatchEventBus } from '@/util/eventBus'
@Component({
    components: { HamburgerButton }
})
export default class PageHeaderWithSearchBar extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({type: Boolean, default: true}) basic!: boolean
    
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    searchMode: boolean = false
    keyword: string = ''

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    async search() {
        if (!this.keyword) {
            await(window as any).alertAsync(this.$t('검색어_입력').toString())
            return false
        }
        dispatchEventBus(window, 'header-search', this.keyword)
        this.searchMode = true
    }

    back() {
        dispatchEventBus(window, 'header-search', '')
        this.keyword = ''
        this.searchMode = false
    }
}